import { fabric } from 'fabric'

const LetterFabricText = fabric.util.createClass(fabric.IText, {
  insertNewline: function() {
    this.exitEditing()
  },
  paste: function(e) {
    e.stopImmediatePropagation()
    e.preventDefault()
  },
})

export default LetterFabricText
